"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClearButtonElement = exports.getIconElement = exports.getInputContainer = exports.getPopoverContentElement = exports.getPopoverElement = exports.getInputElement = exports.getInputWithOptionsElement = exports.getButtonElement = void 0;
function getButtonElement(root) {
    return root.querySelector('button[data-hook="search-button"]');
}
exports.getButtonElement = getButtonElement;
function getInputWithOptionsElement(root) {
    return root.querySelector('div[data-hook="input-with-options"]');
}
exports.getInputWithOptionsElement = getInputWithOptionsElement;
function getInputElement(root) {
    return root.querySelector('input[data-hook="input"]');
}
exports.getInputElement = getInputElement;
function getPopoverElement(root) {
    return root.querySelector('div[data-hook="popover-element"]');
}
exports.getPopoverElement = getPopoverElement;
function getPopoverContentElement(root) {
    return root.querySelector('div[data-hook="popover-content"]');
}
exports.getPopoverContentElement = getPopoverContentElement;
function getInputContainer(root) {
    return root.querySelector('div[data-hook="input"]');
}
exports.getInputContainer = getInputContainer;
function getIconElement(root) {
    return root.querySelector('svg[data-hook="search-icon"]');
}
exports.getIconElement = getIconElement;
function getClearButtonElement(root) {
    return root.querySelector('button[data-hook="clear-button"]');
}
exports.getClearButtonElement = getClearButtonElement;
//# sourceMappingURL=elements.js.map